import { Flex, Text } from '@vtex/admin-ui'
import { useWatch } from '@vtex/admin-ui-form'
import { useIntl } from 'react-intl'
import { FieldGroupBox, RuleStack, useFormStateContext } from 'ui'
import { ProgressiveDiscountTrigger } from '../../../../../../typings'
import { ItemsView } from '../../../../../ItemsView'
import { messages } from '../messages'
import styles from '../styles'

type Props = {
  name: string
  onRemove: () => void
  onEdit: () => void
}

export function ViewTrigger(props: Props) {
  const { name, onRemove, onEdit } = props
  const { form } = useFormStateContext()
  const { $t } = useIntl()

  const trigger: ProgressiveDiscountTrigger = useWatch({ form, name })

  return (
    <Flex direction="column" className={styles.filledBox}>
      <Text>{$t(messages.trigger.description)}</Text>
      <FieldGroupBox name={`${name}.trigger`} withBorder={false}>
        <RuleStack>
          <ItemsView config={trigger} onEdit={onEdit} onRemove={onRemove} />
        </RuleStack>
      </FieldGroupBox>
    </Flex>
  )
}
